import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from '../../../util/reactIntl';
import css from './Sections.module.css';
import { Icons } from '../../../components';
import classNames from 'classnames';

function SectionShipping({ intl }) {
  return (
    <div className={css.shippingContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={classNames(css.featuresContent, css.communitySafety)}>
          <div className={css.communitySafetyHead}>
            <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.title' })}</h2>
            <ul>
              <li>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.description' })}</li>
            </ul>
          </div>
          <div className={css.paymentSafetySec}>
            <div className={css.safetyBlock}>
              <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.ukToUk.title' })}</h2>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.ukToUk.courier' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.ukToUk.delivery' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.ukToUk.shipTime' })}</p>
            </div>

            <div className={css.safetyBlock}>
              <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.euToEu.title' })}</h2>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.euToEu.courier' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.euToEu.delivery' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.euToEu.shipTime' })}</p>
            </div>

            <div className={css.safetyBlock}>
              <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.usToUs.title' })}</h2>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.usToUs.courier' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.usToUs.delivery' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionShipping.usToUs.shipTime' })}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SectionShipping.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionShipping;